import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <section className="bg-[var(--color-page)] py-24">
      <div className="mx-auto max-w-[600px] rounded-[var(--radius-xl)] border border-[var(--color-line)] bg-[var(--color-panel)] px-6 py-12 text-center shadow-[0_12px_36px_rgba(60,41,112,0.08)]">
        <div className="num text-[64px] font-bold text-[var(--color-primary)]">404</div>
        <h1 className="mt-2 text-[24px] font-bold tracking-[0] text-[var(--color-ink-strong)]">
          {t("notFound.title")}
        </h1>
        <p className="mt-3 text-[14.5px] text-[var(--color-text)]">{t("notFound.body")}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-1.5 rounded-[var(--radius-md)] bg-[var(--color-primary)] px-4 py-2.5 text-[13.5px] font-bold text-white hover:bg-[var(--color-primary-deep)]"
        >
          {t("notFound.back")}
        </Link>
      </div>
    </section>
  );
}
